import { Title, Button, Text, Badge } from "@mantine/core";
import { IconCreditCard, IconReceipt2, IconWallet, IconCurrencyShekel, IconArrowLeft } from "@tabler/icons";
import image from "../public/payment.webp";
import { MediaStage } from "./MediaStage";
import classes from "../styles/MiddleSection.module.css";

// זמנו תור ושלמו ב- Quick
export function MiddleSection() {
    const steps = [
        { text: "קבלת תשלום בכל הדרכים בצורה מאובטחת", icon: <IconCreditCard size={20} /> },
        { text: "חשבונית ירוקה אוטומטית לכל לקוח", icon: <IconReceipt2 size={20} /> },
        { text: "תשלום נוח מהנייד ללא צורך באפליקציה", icon: <IconWallet size={20} /> },
        { text: "ריכוז כל ההכנסות במקום מסודר אחד", icon: <IconCurrencyShekel size={20} /> },
    ];

    return (
        <div className={classes.wrapper}>
            <div className={classes.body}>
                <Badge
                    size="lg"
                    variant="light"
                    color="pink"
                    className={classes.badge}
                >
                    סליקה וחשבוניות
                </Badge>

                <Title className={classes.title} order={2}>
                    להיות עסק שלוקח את הכסף שלו ברצינות
                </Title>
                <Text className={classes.subtitle}>
                    למה לרדוף אחרי לקוחות? אפשרו להם לשלם במעמד קביעת התור או בסיומו.
                    הכסף נכנס לחשבון, החשבונית יוצאת ללקוח. וזהו.
                </Text>

                <div className={classes.stepsList}>
                    {steps.map((step, index) => (
                        <div key={index} className={classes.stepItem}>
                            <div className={classes.stepIcon}>
                                {step.icon}
                            </div>
                            <Text className={classes.stepText}>
                                {step.text}
                            </Text>
                        </div>
                    ))}
                </div>

                <Button
                    className={classes.ctaButton}
                    rightSection={<IconArrowLeft size={20} />}
                    component="a"
                    href={"https://app.quicktor.co.il"}
                >
                    אני רוצה להתחיל לסלוק &gt;&gt;
                </Button>
            </div>
            <div className={classes.image}>
                <MediaStage
                    image={image}
                    variant="dark"
                    callouts={["חשבונית ירוקה אוטומטית"]}
                    alt="מסך תשלום על תור בטלפון: סיכום השירות, התאריך והשעה, ותשלום בביט, Google Pay או כרטיס אשראי"
                />
            </div>
        </div>
    );
}
